import styled from 'styled-components'

const lightColor = (props) => props.theme.global.colors['white']
const borderColor = (props) => props.theme.global.colors['light-7']

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  padding: 24px;
  background-color: ${lightColor};

  @media screen and (max-width: 992px) {
    padding: 16px;
  }
`